"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root =
/*#__PURE__*/
(0, _emotion.css)("user-select:none;box-sizing:border-box;> *{margin-bottom:21px;}");

var groups = function groups(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("> *{border-bottom:1px solid ", theme.color.grey3, ";}")
  );
};

var _default = {
  root: root,
  groups: groups
};
exports.default = _default;